import RelatedProductsContent from "./related-products.jsx";
import BundleUpsellContent from "./bundle-upsell.jsx";
import "./cart-compatibility";
import { h, render } from "preact";
import morphdom from "morphdom";
import "./add-product-protection.js";

class Cart extends HTMLElement {
  constructor() {
    super();
    this.cart = this.querySelector("[data-cart]");
    this.mainCart = this.querySelector("[data-main-cart]");
    this.cartContent = null;
    this.relatedProducts = this.querySelector("[data-related-products]");
    this.bundleUpsell = this.querySelector("[data-bundle-upsell]");
    this.bundleUpsellData = this.querySelector("[data-bundle-upsell-product]");
    this.relatedCollection = this.relatedProducts?.dataset?.collection;
    this.initFunction = this.initFunction.bind(this);
    this.loaded = false;
    this.getCart = this.getCart.bind(this);
    this.removeEvents = [];
    window.SLIDECART_UPDATE = () => this.refreshCart();
    this.getCart();

    const handleOpen = () => this.openMiniCart();
    const handleClose = () => this.closeMiniCart();
    const closeEsc = (event) => {
      if (event.code.toUpperCase() !== "ESCAPE") return;

      if (this.isOpen) {
        this.closeMiniCart();
        return;
      }
    };

    document.addEventListener("mini-cart:open", handleOpen);
    document.addEventListener("mini-cart:close", handleClose);
    document.addEventListener("keyup", closeEsc);
  }

  disconnectedCallback() {
    document.removeEventListener("mini-cart:open", handleOpen);
    document.removeEventListener("mini-cart:close", handleClose);
    document.removeEventListener("keyup", closeEsc);
  }

  getCart = async () => {
    await fetch("/cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((data) => data.json())
      .then((response) => {
        if (!response) return;
        this.cartContent = response;
        window.cartContent = response;
        this.initFunction();
      });
  };

  validateCart = async () => {
    if (!this.cartContent.items.length > 0) return;

    const clydeProducts = {};

    this.cartContent.items.forEach((item) => {
      if (item.product_type !== "clyde_contract") return;

      let coveredProduct =
        this.cartContent.items.find(
          (targetItem) =>
            item.properties._productItemVariantId == targetItem.id,
        ) ||
        this.cartContent.items.find(
          (targetItem) =>
            item.properties._productItemVariantId ==
            targetItem.properties._bundleId,
        );

      if (item.properties.Product in clydeProducts) {
        clydeProducts[item.properties.Product].clydeItems.push(item);
      } else {
        clydeProducts[item.properties.Product] = {
          coveredProduct,
          clydeItems: [item],
        };
      }
    });

    const clydeItemUpdates = [];

    Object.values(clydeProducts).forEach(({ clydeItems, coveredProduct }) => {
      if (!coveredProduct) {
        // Remove any clyde items that are not associated with any products in cart
        clydeItemUpdates.push(
          ...clydeItems.map(({ key }) => ({
            key,
            quantity: 0,
          })),
        );
      } else {
        // Reduces qty of clyde items to match associated product
        const totalCoveredQty = clydeItems.reduce(
          (prev, curr) => prev + curr.quantity,
          0,
        );

        let surplus = totalCoveredQty - coveredProduct.quantity;

        if (surplus > 0) {
          clydeItemUpdates.push(
            ...clydeItems.map(({ key, quantity }) => {
              let qtyToRemove = 0;
              if (surplus > 0) {
                qtyToRemove = Math.min(quantity, surplus);
              }

              surplus = surplus - qtyToRemove;

              return {
                key,
                quantity: quantity - qtyToRemove,
              };
            }),
          );
        }
      }
    });

    if (clydeItemUpdates.length) {
      this.updateLineItemQuantity(clydeItemUpdates);
      return;
    }
  };

  shippingBanner() {
    if (!this.hasAttribute("enable-shipping-countdown")) return;

    // Get the current date and time
    const initialDate = new Date().toLocaleString("en-US", {
      timeZone: "America/New_York",
    });

    const currentDate = new Date(initialDate);

    // Get the current day of the week (0 is Sunday, 1 is Monday, etc.)
    const currentDayOfWeek = currentDate.getDay();

    // Check if it's a weekday (Monday-Friday)
    const isWeekday = currentDayOfWeek >= 1 && currentDayOfWeek <= 5;

    // Check if it's before noon EST
    const isBeforeNoonEST = currentDate.getHours() < 12;

    if (isWeekday && isBeforeNoonEST) {
      // Calculate the time until noon EST
      const noonEST = new Date();
      noonEST.setHours(12, 0, 0, 0);
      let timeUntilNoon = Math.floor(
        (noonEST.getTime() - currentDate.getTime()) / 1000,
      );

      // Show the countdown message
      const countdownElementWrapper = document.querySelector(
        ".main-cart__content__countdown__wrapper",
      );
      const countdownElement = document.querySelector(
        ".main-cart__content__countdown",
      );

      const shippingMessage = document.querySelector(
        ".main-cart__shipping-message",
      );

      countdownElementWrapper.classList.add("active");
      if (shippingMessage) {
        shippingMessage.classList.remove(
          "main-cart__shipping-message--margin-bottom",
        );
      }
      countdownElement.innerHTML = `<p class="text--medium">Order in the next <span id="countdown-timer"></span> and in-stock orders ship today</p>`;

      // Update the timer immediately
      const hours = Math.floor(timeUntilNoon / 3600);
      const minutes = Math.floor((timeUntilNoon % 3600) / 60);
      let timerText = "";
      if (hours > 0) {
        timerText = `${hours} hour${hours > 1 ? "s" : ""}, ${minutes} minute${
          minutes > 1 ? "s" : ""
        }`;
      } else {
        timerText = `${minutes} minute${minutes > 1 ? "s" : ""}`;
      }
      document.getElementById("countdown-timer").textContent = timerText;

      // Update the timer every minute
      const countdownTimer = setInterval(() => {
        const hours = Math.floor(timeUntilNoon / 3600);
        const minutes = Math.floor((timeUntilNoon % 3600) / 60);
        let timerText = "";
        if (hours > 0) {
          timerText = `${hours} hour${hours > 1 ? "s" : ""}, ${minutes} minute${
            minutes > 1 ? "s" : ""
          }`;
        } else {
          timerText = `${minutes} minute${minutes > 1 ? "s" : ""}`;
        }
        document.getElementById("countdown-timer").textContent = timerText;

        // Stop the timer when it reaches zero
        if (timeUntilNoon <= 60) {
          clearInterval(countdownTimer);
          countdownElement.remove();
          countdownElementWrapper.classList.remove("active");
          if (shippingMessage) {
            shippingMessage.classList.add(
              "main-cart__shipping-message--margin-bottom",
            );
          }
        }

        timeUntilNoon -= 60; // Subtract one minute
      }, 60000); // Update every minute

      if (timeUntilNoon <= 60) {
        clearInterval(countdownTimer);
        countdownElement.remove();
        countdownElementWrapper.classList.remove("active");
        if (shippingMessage) {
          shippingMessage.classList.add(
            "main-cart__shipping-message--margin-bottom",
          );
        }
      }
    } else if (isWeekday) {
      // It's a weekday after noon EST, so don't show the countdown timer
      console.log("See message from 12:00 am to 11:59 pm");
    } else {
      // It's the weekend, so don't show the countdown banner
      console.log("No countdown banner on weekends");
    }
  }

  initFunction() {
    this.unload();

    this.validateCart();

    const handleWindowClick = (e) => {
      if (
        e.target.hasAttribute("data-main-cart-overlay") ||
        e.target.closest("[data-main-cart-overlay]") ||
        e.target.hasAttribute("data-minicart-close") ||
        e.target.closest("[data-minicart-close]")
      ) {
        this.closeMiniCart(e);
      }
    };

    window?.addEventListener("click", handleWindowClick);
    this.removeEvents.push(() => {
      window.removeEventListener("click", handleWindowClick);
    });

    const BundleUpsell = () => {
      console.log(`bundleUpsell`, this.bundleUpsellData);
      return (
        <BundleUpsellContent
          data={this.cartContent}
          product={this.bundleUpsellData}
        />
      );
    };

    const initToggles = () => {
      document.querySelectorAll(".cart-item__toggle").forEach((item) => {
        const handleItemCtaClick = (e) => {
          e.preventDefault();
          item.classList.toggle("is-active");
        };
        const cta = item.querySelector(".cta");
        cta.addEventListener("click", handleItemCtaClick);
        this.removeEvents.push(() => {
          cta.removeEventListener("click", handleItemCtaClick);
        });
      });
    };

    const handleUpdateCart = async (e) => {
      await this.getCart();
      this.handleCartContent(
        e.detail.cart,
        "openCart" in e.detail.options ? e.detail.options.openCart : true,
      );
      this.bundleUpsell = this.querySelector("[data-bundle-upsell]");
      this.bundleUpsellData = this.querySelector(
        "[data-bundle-upsell-product]",
      );
      this.bundleUpsell && render(<BundleUpsell />, this.bundleUpsell);

      initToggles();

      if (typeof window.SLIDECART_UPDATED === "function") {
        window.SLIDECART_UPDATED();
      }
    };

    document.addEventListener("updateCart", handleUpdateCart);
    this.removeEvents.push(() => {
      document.removeEventListener("updateCart", handleUpdateCart);
    });

    const handleCartClick = (e) => {
      let button =
        e.target.hasAttribute("data-quantity-plus") ||
        e.target.closest("[data-quantity-plus]")
          ? "plus"
          : e.target.hasAttribute("data-quantity-minus") ||
              e.target.closest("[data-quantity-minus]")
            ? "minus"
            : false;
      if (button) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.handleLineItemQuantity(button, e);
      }
    };

    this.cart.addEventListener("click", handleCartClick);

    this.removeEvents.push(() => {
      this.cart.removeEventListener("click", handleCartClick);
    });

    if (!this.loaded) {
      initToggles();
      this.bundleUpsell && render(<BundleUpsell />, this.bundleUpsell);
      this.loaded = true;
    }

    this.relatedProducts &&
      render(
        <RelatedProductsContent
          data={this.cartContent}
          collection={this.relatedCollection}
        />,
        this.relatedProducts,
      );

    let params = new URLSearchParams(document.location.search),
      cart = params.get("c");
    cart && this.openMiniCart();
  }

  openMiniCart() {
    this.returnFocusEl = document.activeElement;
    this.style.display = null;
    window.requestAnimationFrame(() => {
      this.isOpen = true;
      this.querySelector("[data-cart]").classList.add("is-open");
      document.documentElement.classList.add("js-drawer-open");
      window.trapFocus(this, this.querySelector("[data-minicart-close]"));
      this.shippingBanner();
    });
  }

  closeMiniCart() {
    window.removeTrapFocus(this.returnFocusEl);

    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);
      this.style.display = "none";
    };

    this.addEventListener("transitionend", onEnd);

    this.querySelector("[data-cart]").classList.remove("is-open");
    document.documentElement.classList.remove("js-drawer-open");
    this.isOpen = false;
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart",
        target: "[data-main-cart]",
        selector: "[data-main-cart]",
      },
      {
        id: "main-cart",
        target: "[data-cart-heading]",
        selector: "[data-cart-heading]",
      },
      {
        id: "header",
        target: "[data-cart-quantity]",
        selector: "[data-cart-quantity]",
      },
      {
        id: "header",
        target: "[data-cart-total-price]",
        selector: "[data-cart-total-price]",
      },
      {
        id: "main-cart",
        target: "[data-main-cart-heading]",
        selector: "[data-main-cart-heading]",
      },
      {
        id: "main-cart",
        target: "[data-cart-footer]",
        selector: "[data-cart-footer]",
      },
    ];
  }

  async handleLineItemQuantity(type, event) {
    const itemEl = event.target.closest(".cart-item");

    const quantitySelector = event.target.closest(
      "[data-line-item-btn-wrapper]",
    );

    if (!quantitySelector) return;
    const quantityLabel = quantitySelector.querySelector(
      "[data-cart-item-quantity]",
    );
    const { maxQty, key, bundleId } = quantitySelector.dataset;
    const quantity = parseInt(quantityLabel.textContent);
    let newQuantity = quantity;

    if (type == "plus") {
      newQuantity += 1;
      const maxQuantity = parseInt(maxQty) || false;
      if (maxQuantity && newQuantity > maxQuantity) {
        newQuantity = maxQuantity;
      }
    } else {
      newQuantity -= 1;
    }

    if (newQuantity === 0) {
      await window.hideItemWithAnimation(itemEl);
    }

    let items = [
      {
        key,
        quantity: newQuantity,
      },
    ];

    if (quantity != newQuantity) {
      quantityLabel.textContent = newQuantity;
      if (bundleId) {
        this.updateBundleQuantity(bundleId, newQuantity);
      } else {
        this.updateLineItemQuantity(items);
      }
    }
  }

  async updateBundleQuantity(id, qty) {
    let cart = null;
    fetch("/cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((data) => data.json())
      .then((response) => {
        cart = response.items;

        cart.map((item) => {
          if (item.properties._bundleId === id) {
            item.quantity = qty;
          }
        });

        let items = [];
        cart.map((item) => {
          items.push({
            key: item.key,
            quantity: item.quantity,
          });
        });

        this.updateLineItemQuantity(items);
      });
  }

  async updateLineItemQuantity(itemData, bundle) {
    const data = {
      updates: {},
    };

    itemData?.forEach((item) => {
      data.updates[item.key] = item.quantity;
    });

    data.sections = "main-cart,header";

    window.updateCart(data.updates, data.sections);
  }

  refreshCart() {
    const data = {
      updates: {},
    };

    data.sections = "main-cart,header";

    window.updateCart(data.updates, data.sections);
  }

  handleCartContent(response, openDrawer = false) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.querySelector(section.target);
      if (elementToReplace) {
        const existingItemKeys = [
          ...elementToReplace.querySelectorAll("[data-key]"),
        ].map((el) => el.dataset.key);

        const newSection = getSection(
          response.sections[section.id],
          section.selector,
        );
        morphdom(elementToReplace, newSection, {
          onBeforeElUpdated: (fromEl, toEl) => {
            if ("attributesOnly" in fromEl.dataset) {
              fromEl.dataset.attributesOnly.split(",").forEach((attribute) => {
                // skip blanks
                if (!attribute) return;

                fromEl.setAttribute(attribute, toEl.getAttribute(attribute));
              });

              return false;
            }
          },
        });

        if (openDrawer) {
          // Animate in any new items
          const newItemEls = [
            ...elementToReplace.querySelectorAll("[data-key]"),
          ]
            .filter((el) => !existingItemKeys.includes(el.dataset.key))
            .map((el) => el.closest(".cart-item"));

          newItemEls.forEach((el) => window.showItemWithAnimation(el));
        }
      }
    });

    if (openDrawer) {
      this.openMiniCart();
    }
  }

  unload() {
    this.removeEvents.forEach((removeEvent) => removeEvent());
    this.removeEvents = [];
  }
}

if (!customElements.get("section-cart")) {
  customElements.define("section-cart", Cart);
}
